export class TransitionalBanner {
  title: string;
  description: any;
  cta: any;
  logo_new: string;
  logo_old: string;
  image: string;
  attivo: boolean;
  constructor(data: any) {
    this.title = data.title;
    this.description = this.extractDescriptionRictText(data);
    this.cta = data.cta;
    this.image = data.imageSection.fields.file.url;
    this.logo_new = data.logoNew.fields.file.url;
    this.logo_old = data.logoOld.fields.file.url;
    this.attivo = data.attivo;
  }
  // utility
  extractDescriptionRictText(data: any): string {
    return data.description.content.map((x: any) => x.content.map((v: any) => v.value).join(' ')).join('');
  }
}
